import { Navigate, useLocation } from "react-router-dom";
import { PRE_LAUNCH_MODE, PUBLIC_ROUTES } from "@/config/launchMode";

interface PreLaunchGuardProps {
  children: React.ReactNode;
}

const PreLaunchGuard = ({ children }: PreLaunchGuardProps) => {
  const location = useLocation();

  // If not in pre-launch mode, allow all routes
  if (!PRE_LAUNCH_MODE) {
    return <>{children}</>;
  }

  // Check if current route is allowed in pre-launch mode
  const isPublicRoute = PUBLIC_ROUTES.some(route => 
    location.pathname === route || location.pathname.startsWith(route + '/')
  );

  // If route is not public, redirect to teaser page
  if (!isPublicRoute) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default PreLaunchGuard;
